import { render, staticRenderFns } from "./ProductCategoryDialog.vue?vue&type=template&id=6ef5c6ed&scoped=true&lang=pug&"
import script from "./ProductCategoryDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCategoryDialog.vue?vue&type=style&index=0&id=6ef5c6ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5c6ed",
  null
  
)

export default component.exports